import React, { Fragment } from 'react'
import './profileSeller.scss'

import Navbar from "../../components/newNavbar/navbar";
import ProfileExib from "../../components/profileExib/profileExib";
import CommentCard from "../../components/commentCard/commentCard";
import { UserId } from '../../queries/player';
import Loading from '../../components/loading/loading'
import { Query, Mutation } from "react-apollo"
import Modal from '../../components/Modal/modal'
import { CreatePropose } from '../../queries/propose'
import dayjs from 'dayjs'
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore'
import ErrorM from '../../components/ErrorMessange/errormenssage'
import { TOOLS } from '../../utilits/tools'
import { GraphQLClient } from 'graphql-request'
import * as emailjs from 'emailjs-com'
import * as totalvoice from 'totalvoice-node'
import { endpoint, tokensms } from '../../queries/endpoint'
import Simplert from 'react-simplert'
import DateRangePicker from '@wojtekmaj/react-daterange-picker'
import Button from '../../components/newButton/button'
import Input from '../../components/newInput/input'
import Back from '../../components/backButton/backButton'
import PhotoZoom from "../../components/photoZoom/photoZoom";
import ErrorBoundary from '../../components/errorBoundary/errorBoundary'

const clientSms = new totalvoice(tokensms)
dayjs.extend(isSameOrBefore)

export default class ProfileSeller extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            page: null,
            show: false,
            anuncio: {},
            loading: false,
            dateok: false,
            dateErr: null,
            valueok: false,
            showAlert: false,
            typeAlert: '',
            titleAlert: '',
            messageAlert: '',
            customCloseBtnText: 'Fechar',
            customCloseBtnClass: 'buttonnot',
            valueErr: null,
            timeErr: null,
            descripOk: false,
            descripErr: null,
            UserId: "",
            date: ['', ''],
            openZoom: false,
            zoomUrl: '',
            zoomAlt: ''
        }

        this.form = {}

        this.openPropose = (anuncio) => {
            const cache = JSON.parse(sessionStorage.getItem('OITO'))

            if (cache) {
                this.UserId = cache.user.id
                this.form.location = cache.user.address ? cache.user.address.city + " - " + cache.user.address.state : null
                this.setState({
                    show: !this.state.show,
                    anuncio,
                    UserId: cache.user.id
                })
            } else {
                // console.log("deveria redirecionar")
                // window.location.href = '/login'

                const listHistory = {
                    count: 0,
                    path: window.location.pathname
                }

                sessionStorage.setItem('LastURL', JSON.stringify(listHistory))
                console.log(sessionStorage.getItem('LastURL'))

                this.setState({
                    showAlert: true,
                    typeAlert: 'error',
                    titleAlert: 'Você não está logado!',
                    messageAlert: 'Entre ou cadastre-se. É gratuito!',
                    onClose: () => window.location.href = '/login'
                })
            }

        }

        this.onChangedata = date => {
            this.setState({ showAlert: false, date: [new Date(), new Date()], dateErr: null, dateok: false })
            console.log(this.state.date)
            if (date) {
                this.form.dateInit = date[0]
                this.form.dateEnd = date[1]

                // console.log(dayjs().isSameOrBefore(this.form.dateInit))

                // console.log(dayjs().isBefore(this.form.dateInit) && dayjs(this.form.dateInit).isBefore(this.form.dateEnd))
                if (dayjs().isSameOrBefore(this.form.dateInit) && dayjs(this.form.dateInit).isSameOrBefore(this.form.dateEnd)) {
                    this.setState({ dateok: true, dateErr: null, date: date })
                    console.log(this.state.date)
                } else {
                    this.setState({
                        dateok: false,
                        dateErr: <ErrorM color="danger" content='Você não pode enviar uma proposta com data atual ou anterior.' />
                    })
                }
            } else {
                this.form.dateInit = ''
                this.form.dateEnd = ''
                this.setState({
                    dateok: false,
                    dateErr: <ErrorM color="danger" content='É necessário escolher uma data. Ela pode ser alterada depois.' />
                })
            }
        }

        this.setInput = event => {
            this.setState({ valueInput: event.target.value });
            this.form[`${event.target.name}`] = event.target.value
            return this.state.valueInput
        } //_setInput

        this.timeValue = e => {
            this.setState({ timeErr: null })
            console.log(e.target.value)
            if (e.target.value) {
                this.form[e.target.name] = TOOLS.formatTime(parseInt(TOOLS.onlyNumbers(e.target.value)))
                this.setState({ timeErr: null })

                if (e.target.value === "00:00" || e.target.value === "0") this.setState({
                    timeErr: <ErrorM color="warning" content='Não é obrigatório, mas seria legal informar o horário que você precisa do serviço. Ele pode ser alterado depois.' />
                })
            } else {
                this.form[e.target.name] = "00:00"
                this.setState({
                    timeErr: <ErrorM color="warning" content='Não é obrigatório, mas seria legal informar o horário que você precisa do serviço. Ele pode ser alterado depois.' />
                })
            }


            return (e.target.value = this.form[e.target.name]);
        }

        this.description = () => {
            if (this.form.description) {
                if (this.form.description.length > 5) {
                    this.setState({ descripOk: true, descripErr: null })
                } else {
                    this.setState({
                        descripOk: false,
                        descripErr: <ErrorM color="danger" content='Descreva rapidamente o que precisa. Ex.: "Você poderia ser o DJ da minha festa?""Você poderia prestar serviço de manobrista no meu evento?"' />
                    })
                }
            } else {
                this.setState({
                    descripOk: false,
                    descripErr: <ErrorM color="danger" content='Descreva rapidamente o que precisa. Ex.: "Você poderia ser o DJ da minha festa?""Você poderia prestar serviço de manobrista no meu evento?"' />
                })
            }
        }

        this.sendRegister = (e, createPropose) => {
            e.preventDefault()
            this.setState({ loading: true })
            console.log("criando proposta")
            // console.log(this.state.anuncio)
            // console.log(this.form)

            if (this.state.dateok &&
                this.state.descripOk &&
                this.form.userPro.toString() !== this.state.UserId.toString()) {

                const date = new Date()
                const now = date.toISOString()
                // console.log(now)


                createPropose({
                    variables: {
                        anunciosId: this.state.anuncio.id,
                        dateInit: this.form.dateInit,
                        dateEnd: this.form.dateEnd,
                        timeInit: this.form.timeInit,
                        timeEnd: this.form.timeEnd,
                        status: "Serviço Aberto para Negociação",
                        valueInit: this.state.anuncio.price ? this.state.anuncio.price : "à combinar",
                        userPro: this.form.userPro.toString(),
                        userCli: this.state.UserId.toString(),
                        description: this.form.description,
                        location: this.form.location,
                        date: now
                    }
                }).then(
                    res => {
                        console.log(res)
                        if (res.data.createPropose) {
                            const cache = JSON.parse(sessionStorage.getItem('OITO'))

                            const propose = res.data.createPropose

                            const client = new GraphQLClient(endpoint, {
                                headers: {
                                    Authorization: `Bearer ${cache.token}`,
                                },
                            })

                            client.request(`
                                        mutation{
                                        createNotification(
                                        userId: "${propose.from.id}",
                                        title: "Proposta enviada",
                                        description: "Entre em contato com o vendedor para negociar.",
                                        link: "/perfil/proposedetails/${propose.id}",
                                        date: "${now}"
                                        ){
                                        id
                                        title
                                        }
                                        } `)

                            client.request(`
                                        mutation{
                                        createNotification(
                                        userId: "${propose.to.id}",
                                        title: "Proposta recebida",
                                        description: "Você recebeu uma solicitação. Entre em contato para fechar negócio.",
                                        link: "/perfil/proposedetails/${propose.id}",
                                        date: "${now}"
                                        ){
                                        id
                                        title
                                        }
                                        } `)

                            //enviar email
                            var template_params2 = {
                                "email": propose.to.email,
                                "name": propose.to.name,
                            }

                            emailjs.send('noreply', 'env_proposta', template_params2, "user_IagwdTtEr3AVRdLhxkyKc")
                                .then((response) => {
                                    console.log('SUCCESS!', response.status, response.text)
                                    this.form = {}
                                }, function (error) {
                                    console.log('FAILED...', error)
                                });


                            const phone = propose.to.phone.replace("(", "").replace(")", "").replace(" ", "").replace("-", "").replace("+55", "")
                            // console.log(phone)
                            console.log("enviando msg")
                            clientSms.sms.enviar(phone, "Você recebeu uma nova solicitação de serviço na Oito! Acesse oito.app e responda a solicitação o quanto antes. Oito App")
                                .then(function (data) {
                                    // console.log(data)
                                    console.log("sms enviado")
                                })
                                .catch(function (error) {
                                    console.error('Erro: ', error)
                                });

                            var template_params = {
                                "email": propose.from.email,
                                "name": propose.from.name,
                            }

                            emailjs.send('noreply', 'send_proposta', template_params, "user_IagwdTtEr3AVRdLhxkyKc")
                                .then((response) => {
                                    console.log('SUCCESS!', response.status, response.text)
                                    this.setState({
                                        loading: false,
                                        showAlert: true,
                                        typeAlert: 'success',
                                        titleAlert: 'Solicitação enviada com sucesso!',
                                        messageAlert: 'Aguarde o profissional entrar em contato.',
                                        onClose: () => window.location.href = `/perfil/proposedetails/${propose.id}`
                                    })
                                    this.form = {}
                                }, function (error) {
                                    console.log('FAILED...', error);
                                    // this.setState({
                                    //     loading: false,
                                    //     showAlert: true,
                                    //     typeAlert: 'error',
                                    //     titleAlert: 'Mensagem não enviada!',
                                    //     messageAlert: 'Ocorreu um problema. Tente novamente.'
                                    // })
                                })
                            this.setState({
                                loading: false,
                                show: false,
                                showAlert: true,
                                typeAlert: 'success',
                                titleAlert: 'Solicitação enviada com sucesso!',
                                messageAlert: 'Aguarde o profissional entrar em contato.',
                                onClose: () => window.location.href = `/perfil/proposedetails/${propose.id}`
                            })
                            this.form = {}
                        }
                    }
                ).catch(err => console.log(err))
            } else {
                if (this.form.userPro.toString() === this.state.UserId.toString()) {
                    this.setState({
                        loading: false,
                        show: false,
                        showAlert: true,
                        typeAlert: 'error',
                        titleAlert: 'Solicitação não enviada!',
                        messageAlert: 'Não é possivel enviar uma solicitação para você mesmo.',
                        onClose: () => {
                            this.form = {}
                            this.setState({ showAlert: false, date: ['', ''] })
                        }
                    })
                }
                if (!this.state.dateok) {
                    this.setState({
                        dateErr: <ErrorM content='É necessário escolher uma data. Ela pode ser alterada depois.' />, loading: false
                    })
                }
                if (!this.state.descripOk) {
                    this.setState({
                        descripErr: <ErrorM content='Descreva rapidamente o que precisa. Ex.: "Você poderia ser o DJ da minha festa?" "Você poderia prestar serviço de manobrista no meu evento?"' />, loading: false
                    })
                }
            }
        } //enviar cadastro
    }

    openZoom = () => {
        this.setState({ openZoom: !this.state.openZoom })
    };

    openImg = (imgUrl, imgAlt) => {
        this.openZoom();
        this.setState({ zoomUrl: imgUrl, zoomAlt: imgAlt })
    }

    filterAnun = (list, skill) => {
        // console.log(list)
        // console.log(skill)
        if (skill !== '' && skill !== null)
            list.filter((anuncio) => {
                if (anuncio.skills.id === skill) {
                    if (this.state.page === null) {
                        return this.setState({ page: anuncio })
                    } else {
                        return null
                    }
                } else {
                    return null
                }
            })
    }

    choosePage = () => {
        const { page } = this.state
        if (page && !page.skills) {
            let list = []
            page.map(com =>
                com.typeTo === "PROFISSIONAL" ?
                    list.push(com) : null)

            return list.length > 0 ? list.map((com, i) => (
                <CommentCard comment={com} key={i} />)) : <p>Este profissional nao possui comentários ainda</p>

        } else if (page && page.skills) {
            return <div className="skill-desc col-xs-12">
                {/*<p>{page.id}</p>*/}
                {/*<p>{page.skills.id}</p>*/}

                <div className={'infos col-xs-12'}>
                    <div>
                        {/* <p><strong>Skill: </strong>{page.skills.name}</p> */}
                        <h2 style={{ fontWeight: "normal" }}>{page.description}</h2>
                        <p><strong>Preço: </strong>{page.price ? page.price : 'á combinar'}</p>
                    </div>
                    <div>
                        <Button onClick={() => this.openPropose(page)} name={"Enviar solicitação"} />
                    </div>
                </div>
                <h3>Fotos</h3>
                <div className={'filephotos col-xs-12'}>
                    {page.files ? page.files.length > 0 ? page.files.map((img, i) => (
                        <img src={img.url} alt={img.name} style={{ cursor: 'pointer' }} key={i} onClick={() => this.openImg(img.url, img.name)} />
                    )) : <p>Este profissional ainda não possui fotos</p> : <p>Este profissional ainda não possui fotos</p>}
                </div>
            </div>
        }
    }

    render() {
        const tomorrow = new Date(dayjs(new Date()).add(1, 'day'))
        return (
            <Fragment>
                <Navbar />

                <Simplert
                    showSimplert={this.state.showAlert}
                    type={this.state.typeAlert}
                    title={this.state.titleAlert}
                    message={this.state.messageAlert}
                    customCloseBtnText={this.state.customCloseBtnText}
                    customCloseBtnClass={this.state.customCloseBtnClass}
                    onClose={this.state.onClose}
                />

                {this.state.openZoom ? <ErrorBoundary><PhotoZoom onClose={this.openZoom} imgUrl={this.state.zoomUrl} imgAlt={this.state.zoomAlt} /></ErrorBoundary> : null}

                <div className={'profileUser col-xs-12'} style={{ maxWidth: "980px" }}>
                    <Query query={UserId} variables={{ id: window.location.pathname.split('/')[(window.location.pathname.split('/').length - 1)] }}>
                        {res => {
                            if (res.loading) return <Loading />
                            if (res.error) return <p>Algo de errado aconteceu. Tente novamente.</p>

                            const player = res.data.user

                            let proRate = 0

                            // console.log(player)

                            this.form.userPro = player.id

                            if (player.ranks.length) {
                                let notes = []
                                // console.log("cliente", res.data.allRanks)
                                player.ranks.map(rank => (
                                    rank.typeTo === "PROFISSIONAL" ?
                                        notes.push(rank.media) : null
                                ))
                                // console.log(notes)
                                if (notes.length) proRate = parseInt(notes.reduce((sum, num) => sum + num) / notes.length)
                                // console.log(clientRate)
                            }

                            let skills = []

                            if (player.anuncios) {
                                player.anuncios.map(an => (
                                    an.active ? skills.push(an.skills.name) : null
                                ))
                            }

                            if (player) return <>
                                <ErrorBoundary>
                                    <ProfileExib name={player.name} imgUrl={player.photo} city={player.address} resume={player.description} rank={proRate} rlist={player.ranks} />
                                </ErrorBoundary>
                                {/*<section className="sharing">*/}
                                {/*    /!*<h1>Compartilhar perfil deste profissional</h1>*!/*/}
                                {/*</section>*/}
                                <div className={'skills-btn row'}>
                                    {player.anuncioses ? player.anuncioses.map((an, i) => (
                                        an.active ?
                                            <span key={i} className={this.state.page && this.state.page.id === an.id ? "active" : null} onClick={() => this.setState({ page: an })}>
                                                {an.skills.name}
                                                {this.state.page === null ? this.setState({ page: an }) : null}
                                            </span> : null
                                    )) : null}
                                    <span className={this.state.page && !this.state.page.skills ? "active" : null} onClick={() => this.setState({ page: player.commentsTo })}>Comentários</span>
                                </div>
                                <Back />
                                <div className="row">
                                    {/* {console.log(window.location.search)} */}
                                    {this.filterAnun(player.anuncios, window.location.search.split('?')[(window.location.search.split('?').length - 1)])}

                                    {/* {window.location.search? this.setState({ page: window.location.search.split('?')[(window.location.search.split('?').length - 1)] }) : null} */}
                                    {this.choosePage()}
                                </div>

                                {this.state.anuncio && this.state.anuncio.id !== undefined ?
                                    <Modal show={this.state.show} title={`Solicitar serviço de ${this.state.anuncio.skill.name} a ${player.name}`} onClose={() => this.setState({ show: !this.state.show })} >
                                        {/* {console.log(this.state.anuncio.id)} */}
                                        {this.state.loading ? <Loading /> :
                                            <form className="row start-xs">
                                                <div className="col-xs-12">
                                                    <h5>Data: </h5>
                                                    <DateRangePicker onChange={this.onChangedata} value={this.state.date} required={true} minDate={tomorrow} />
                                                    {this.state.dateErr}
                                                </div>
                                                <div className="col-xs-12 col-sm-6" style={{ marginTop: '25px' }}>
                                                    <Input icon="far fa-clock" name="timeInit" label="Horário de início" placeholder="Horário de início. Ex. 18:00" type="text" onInput={this.setInput} onKeyUp={this.timeValue} value={this.form.timeInit} maxlength={6} />
                                                </div>

                                                <div className="col-xs-12 col-sm-6" style={{ marginTop: '25px' }}>
                                                    <Input icon="far fa-clock" name="timeEnd" label="Horário de encerramento" placeholder="Horário de encerramento. Ex. 23:00" type="text" onInput={this.setInput} onKeyUp={this.timeValue} value={this.form.timeEnd} maxlength={6} />
                                                </div>
                                                {this.state.timeErr}

                                                <div className="col-xs-12">
                                                    <Input name="location" label="Local do serviço" placeholder="Local do serviço. Ex. Cidade - Estado" type="text" onInput={this.setInput} defaultValue={this.form.location} />
                                                </div>

                                                <div className="col-xs-12">
                                                    <Input icon="far fa-file-alt" name="description" label="Descrição" placeholder="Breve descrição do serviço." type="text" onInput={this.setInput} onKeyUp={this.description} maxlength={254} required />
                                                    {this.state.descripErr}
                                                </div>
                                                <Mutation mutation={CreatePropose}>
                                                    {(CreatePropose, { loading, error }) => {
                                                        if (loading) return <Loading />
                                                        if (error) return <p>Algo de errado aconteceu. Tente novamente.</p>
                                                        return <Button name='Enviar proposta' type='submit' onClick={(e) => this.sendRegister(e, CreatePropose)} />
                                                    }}
                                                </Mutation>
                                            </form>}
                                    </Modal>
                                    : null}
                            </>
                        }}
                    </Query>
                </div>
            </Fragment>
        )
    }
}
